var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimpleIllustrationEmailAddress = function SvgSimpleIllustrationEmailAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "simple-illustration__email-address_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 101 100",
    style: {
      enableBackground: "new 0 0 101 100"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".simple-illustration__email-address_svg__st1{fill:#ffeaaa}.simple-illustration__email-address_svg__st3{fill:none;stroke:#002140;stroke-linecap:round;stroke-linejoin:round}")), /*#__PURE__*/React.createElement("path", {
    d: "m83.4 41-.1-5s-1.9-4.2-2.8-4.3c-.9-.1-29.6-10.2-29.6-10.2s-2.7.7-3.6.9c-1 .2-26.4 9-26.4 9s-2.4 1.1-3.1 3.9-.9 6.4-.9 6.4-.7.7-.8 2.2c-.1 1.5.1 32.7.1 32.7s-.2 1.9 2.1 2c2.3.1 65.7 0 65.7 0s1.2-1 1.2-2.2.4-34 .4-34-1-1.6-2.2-1.4z",
    style: {
      fill: "#fffaf0"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9 55.4s3.6-14.2 1.7-14.1c-1.9 0-16.3.3-16.3.3s-1.3.3-1.3 1.3v1l15.9 11.5zM64.6 57.4c.6 1.3 21-15 21-15s-.6-1.7-2.2-1.4c-1.7.3-10.5-.7-13 .3-2.7 1-6.4 14.8-5.8 16.1z",
    className: "simple-illustration__email-address_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m25.1 46 .7 4.8 9.5 6.9 30.1-.3s8.1-6.8 8.9-6.9c.7-14.4 8.3-28.4 8.3-28.4l-1.1-.8-5.3.9-3.1-2.9-4.9 3.2-4.5-3.6-5.7 3.3-3.4-3.7-5.7 3.4-2.3-4.4-5.5 4.1-4.7-3.9c0-.1-11.3 5.1-11.3 28.3z",
    style: {
      fill: "#b1f2d6"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8 41.3h-7.3c-1 0-1.7.8-1.7 1.7v34c0 1 .8 1.7 1.7 1.7h66.2c1 0 1.7-.8 1.7-1.7V43c0-1-.8-1.7-1.7-1.7h-7.8M24.7 78.6l10.4-20.5M64.8 57.9l9.8 20.7M79 31.4l.6.2c2.2.8 3.7 2.8 3.7 5.1v4.2M17.2 40.8v-4.4c0-2.3 1.5-4.4 3.7-5.1l7-2.4",
    className: "simple-illustration__email-address_svg__st3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16 44.2 19.2 13.6h29.6L85.4 43",
    className: "simple-illustration__email-address_svg__st3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3 50.8S20.9 33.3 36.5 17l3.8 4.9 6-4.6 2.7 4.6 5.6-3.9 3.9 4.2 5.4-3.8 4.2 4.2 5.7-3.6 3.6 3.8s3.8-1.5 6-1.8c-8.3 14.7-8.9 29.7-8.9 29.7",
    className: "simple-illustration__email-address_svg__st3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.6 51c2.1 0 4.1-.4 5.1-.8.9-.3 1.1-.7 1.1-1.2s-.4-.6-.6-.6c-.6 0-1.7.7-4.9.7-5.2 0-8.3-3-8.3-7.3 0-5.8 4.2-9.6 9.5-9.6 4.9 0 8.2 2.8 8.2 7.5 0 3.1-1.4 5.3-2.9 5.3-.9 0-1-.9-.9-1.6l.5-4.6c.2-2.3.5-2.6.5-3.2 0-.4-.2-.6-.7-.6-.7 0-1.3.5-1.8 1.2-.8-.8-2-1.3-3.5-1.3-3.6 0-6.3 2.8-6.3 6.7 0 2.9 1.8 4.8 4.4 4.8 1.7 0 3.1-.8 4.1-2 .3 1.6 1.5 2.5 3.3 2.5 3.2 0 5.8-3.2 5.8-7.5 0-5.4-4.1-9-10.3-9-7.4 0-12.7 4.9-12.7 11.7 0 5.4 4.1 8.9 10.4 8.9zm-1.4-9.3c0-3 1.2-5.1 2.9-5.1 1.1 0 2 .8 2 2.7 0 3-1.2 5.2-2.9 5.2-1.1 0-2-1-2-2.8z",
    style: {
      fill: "#002140"
    }
  }));
};
export default SvgSimpleIllustrationEmailAddress;